(function($, moment, Calculator, CalculatorContext) {
	"use strict";

	/**
	 * Ce plugin crée un popin permettant de définir les filtres avancés :
	 *
	 * @param {String} title - le titre du popin
	 * @param {String} langCode - le code (fr, en, ...) de la langue à utiliser, parmi les langues supportées $.fn.materialPopinFilters.langs
	 * @param {Array(name, title, nullable, operators, appendEditor, getEditorValue)} fields - la liste des champs disponibles
	 * @param {Array(field, operator, value)} filters - la liste des filtres définis par l'utilisateur
	 * @param {String} association - la manière de combiner les filtres, qui peut être 'and' (par défaut), 'or' ou 'custom' (expression)
	 * @param {String} expression - l'expression combinant les filtres, quand association est 'custom'
	 * @param {Function(filters, association, expression)} callback - la méthode appelée en cas de changement validés par l'utilisateur
	 */
	$.fn.materialPopinFilters = function(title, langCode, fields, filters, association, expression, callback) {
		// Récupération de la langue
		var lang = $.fn.materialPopinFilters.langs[langCode];

		// Création du template
		var div = $(this);
		div.append(''
				+ '<div>'
				+ '  <div class="dropdown">'
				+ '    <button class="btn btn-link dropdown-toggle" type="button" data-toggle="dropdown">'
				+ '      ' + lang['AddButton'] + ' <span class="caret"></span>'
				+ '    </button>'
				+ '    <ul class="dropdown-menu"></ul>'
				+ '  </div>'
				+ '</div>'
				+ '<div class="row" style="max-width: 500px; margin: 20px auto 0;">'
				+ '  <div class="col-md-4">'
				+ '    <input type="radio" name="association" id="association.and" value="and" />'
				+ '    <label for="association.and">' + lang['AndAssociation'] + '</label>'
				+ '  </div>'
				+ '  <div class="col-md-4">'
				+ '    <input type="radio" name="association" id="association.or" value="or" />'
				+ '    <label for="association.or">' + lang['OrAssociation'] + '</label>'
				+ '  </div>'
				+ '  <div class="col-md-4">'
				+ '    <input type="radio" name="association" id="association.custom" value="custom" />'
				+ '    <label for="association.custom">' + lang['CustomAssociation'] + '</label>'
				+ '  </div>'
				+ '  <input type="text" class="form-control" value="" placeholder="' + lang['FormulaPlaceholder'] + '" style="clear: both; margin-top: 20px;" />'
				+ '  <div class="text-danger" style="display: none;">' + lang['FormulaError'] + '<span class="details"></span></div>'
				+ '</div>'
				+ '<table style="width: 100%; max-width: 100%; margin-top: 20px; table-layout: fixed; ">'
				+ '  <thead>'
				+ '    <tr>'
				+ '      <th style="width: 24px; ">&nbsp;</th>'
				+ '      <th style="width: 24px; ">' + lang['NumberColumn'] + '</th>'
				+ '      <th style="width: auto; ">' + lang['FieldColumn'] + '</th>'
				+ '      <th style="width: auto; ">' + lang['OperatorColumn'] + '</th>'
				+ '      <th style="width: auto; ">' + lang['ValueColumn'] + '</th>'
				+ '    </tr>'
				+ '  </thead>'
				+ '  <tbody>'
				+ '  </tbody>'
				+ '  <tfoot style="display: none;">'
				+ '    <tr>'
				+ '      <td class="delete"><a href="#" class="material-icons" title="">delete</a></td>'
				+ '      <td class="number"></td>'
				+ '      <td class="field"></td>'
				+ '      <td class="operator"><select class="form-control" style="padding-right: 16px;"></select></td>'
				+ '      <td class="value"></td>'
				+ '    </tr>'
				+ '  </tfoot>'
				+ '</table>'
				+ '');

		// Remplir le menu déroulant avec les champs possibles
		div.find('.dropdown').children('ul').append(fields.map(function(field) {
			var a = $('<a href="#" />').text(field.title).attr('data-name', field.name);
			return $('<li />').append(a).get(0);
		}));

		// Ecouter la sélection dans le menu déroulant pour ajouter une ligne dans le tableau
		div.find('.dropdown').on('click', 'a', function(event) {
			// Eviter le # dans l'URL
			event.preventDefault();
			// Ajouter une ligne dans le tableau
			addFilter({ field: $(event.target).attr('data-name') });
			if (! table.is(':visible'))
				// Afficher le tableau si au moins un critère
				table.show();
			else
				// Afficher les modes d'association si au moins 2 critères
				associationDiv.show();
		});

		// Prendre en compte l'association and/or/custom
		var associationDiv = div.children('.row').toggle(filters.length >= 2);
		var associationRadios = associationDiv.find('input[type=radio]');
		var formulaInput = associationDiv.children('input[type=text]').val(expression);
		associationRadios.materialRadio({}).val([association]).on('change', function(event) {
			var val = associationRadios.filter(':checked').val();
			if ('custom' === val)
				formulaInput.show().select();
			else
				formulaInput.hide().next().hide();
		}).change(); /*afficher / cacher la zone pour la formule */

		// Récupérer le tableau contenant les critères saisis par l'utilisateur
		var table = div.children('table');
		// Afficher le tableau si au moins une ligne présente
		table.toggle(filters.length >= 1);
		// Ecouter le changement d'opérateur
		table.on('change', '.operator > select', function() {
			// Cacher la valeur à droite du select pour les opérateurs 'isEmpty' et 'isNotEmpty'
			$(this).closest('td').next().toggle(this.value !== 'isEmpty' && this.value !== 'isNotEmpty');
		});
		// Ecouter le clic sur les boutons de suppression
		table.on('click', '.delete > a', function(event) {
			// Eviter le # dans l'URL
			event.preventDefault();
			// Supprimer la ligne
			$(this).closest('tr').remove();
			// Renuméroter les autres lignes
			var siblings = table.find('>tbody>tr').each(function(index, tr) {
				$(tr).children('.number').text(index + 1);
			});
			// Afficher / cacher en fonction du nombre de lignes restantes
			associationDiv.toggle(siblings.length >= 2);
			table.toggle(siblings.length >= 1);
		});
		// Remplir le tableau
		filters.forEach(addFilter);

		function addFilter(filter) {
			var field = fields.filter(function(f) { return f.name === filter.field; })[0];
			// Création de la ligne en clonant le template
			var tr = table.find('>tfoot>tr').clone()
				.attr('data-name', filter.field)
				.appendTo(table.children('tbody'));
			// Numérotation de ligne
			tr.children('.number').text(tr.index() + 1);
			// Nom de champ pour la ligne
			tr.children('.field').text(field.title);
			// Zone de saisie de valeur, on fonction du type de champ
			field.appendEditor(tr.children('.value'), filter.value, langCode);
			// Liste des opérateur de la ligne
			tr.children('.operator').children('select').append(field.getOperators().map(function(operator) {
				return $('<option />').attr('value', operator).text(lang.operators[operator]).prop('selected', operator === filter.operator)[0];
			})).change();
			return tr;
		}

		// Création d'un calculateur pour vérifier les formules, si dispo
		if (Calculator && 'addOperator' in Calculator.prototype) {
			var calculator = createCalculator(lang);
			// Vérification de la formule à la volée
			formulaInput.activateChangeOrKeyUpEnter().on('changeorkeyupenter', function() {
				var formula, tree, i;
				try {
					// Création de N token, un pour chaque ligne de la grille, afin de tapper les formules "1 et (2 ou 3)" par exemple
					calculator.literals = {};
					for (i = table.children('tbody')[0].childElementCount; i >= 1; i--) {
						calculator.addLiteral(i.toString(), true/*peu importe la valeur pour l'instant*/);
					}
					// Interprétation de la formule
					formula = formulaInput.val();
					tree = calculator.parse(formula);
					// Ici, on joue sur le fait que le "calculate" appellera l'une des 2 fonctions de manière
					// SYNCHRONE car les litéraux et les opérateurs &&, || et ! sont synchrones.
					// Ca ne marcherait pas avec des fonctions asynchrones par contre.
					new CalculatorContext(calculator).calculate(tree, function(value) {
						if (typeof value !== 'boolean')
							throw new Error(lang['FormulaResultTypeError']);
						formulaInput.next('.text-danger').hide();
						formulaInput.parent().removeClass('has-error');
						// pour reformater la formule
						// formulaInput.val(calculator.format(tree));
					}, function(error) {
						// affichera 'Formule incorrecte'
						throw new Error('');
					});
				} catch (e) {
					// Si possible, afficher dans l'input la partie qui a lancé l'erreur
					if (typeof e.select === 'function')
						e.select(formulaInput[0]);
					// En tout cas, afficher le message 'Formule incorrecte'
					formulaInput.next('.text-danger').show();
					formulaInput.parent().addClass('has-error');
					// Si possible, afficher le détail de l'erreur, traduit dans la bonne langue
					var error = e.message || '';
					if (typeof e.format === 'function')
						error = e.format(function(e) { return lang.errors[e] || e; });
					formulaInput.next('.text-danger').children('.details').text(error ? (' (' + error + ')') : '');
				}
			});
		}

		// Affichage du popin une fois que tout est prêt
		div.materialPopin({
			title: title,
			closeButtonTitle: lang['CancelButton'],
			buttons : [{
				icon : 'done',
				visible : true,
				title: lang['ValidateButton'],
				onclick : function validate() {
					// On récupère les filtres (un tableau), l'association (and/or/custom) et la formule (si 'custom')
					var filters = [];
					var association = div.find('> .row input[type=radio]:checked').val();
					var expression = div.find('> .row input[type=text]').val();
					// Empêcher la validation si la formule est nécessaire mais incorrecte
					if ('custom' === association && div.children('.row').is('.has-error')) {
						div.children('.row').hide().fadeIn();
						return;
					}
					// On parcourt la table pour extraire les filtres sous la forme d'un tableau { field, operator, value }
					div.find('>table>tbody>tr').each(function() {
						// Parcourir chaque ligne du tableau
						var tr = $(this);
						// Récupérer le champ, pour son nom et la manière d'obtenir la valeur
						var field = fields.filter(function(f) { return f.name === tr.attr('data-name'); })[0];
						// Récupérer l'opérateur 'equals', 'isEmpty', ...
						var operator = tr.children('.operator').children('select').val();
						// Récupérer la valeur TYPEE, par exemple un entier, un booléen, une String, un tableau d'id, ...
						var value = field.getEditorValue(tr.children('.value'));
						// Ajouter le filtre correspondant à la ligne
						filters.push({ field: field.name, operator: operator, value: value });
					});
					// Une fois récupérées les données, appeler la callback avec les nouveaux filtres, validés par l'utilisateur
					callback(filters, association, expression);
					// Enfin, fermer le popin
					div.materialPopin('close');
				}
			}, {
				icon : 'delete',
				visible : true,
				title: lang['ClearButton'],
				onclick : function clear() {
					// Quand on vide les filtres, il suffit d'appeler la callback avec 0 filtre
					callback([], 'and', '');
					// Puis de fermer le popin
					div.materialPopin('close');
				}
			}]
		});

		// Vérifier la formule dès que le popin est visible
		// (sous IE, ça plante si on le fait avant que l'input soit visible)
		if ('custom' === association)
			formulaInput.trigger('changeorkeyupenter');
	};

	/**
	 * Cette fonction crée un "Calculator", utilisée aussi bien pour vérifier la formule que pour appliquer les filtres
	 *
	 * @param {String} lang - l'une des 3 langues supportées par le composant
	 */
	function createCalculator(lang) {
		var calculator = new Calculator();
		// L'opérateur logique "non" (unaire préfixe)
		calculator.addOperator(lang['NotToken'], 3, 'prefix', function(context, resolve, reject, a) {
			context.calculate(a, function(result) {
				resolve(! result);
			}, reject);
		});
		// L'opérateur logique "et" (binaire associatif gauche)
		calculator.addOperator(lang['AndAssociation'], 2, 'left',  function(context, resolve, reject, a, b) {
			context.calculate(a, function(result) {
				if (!result)
					resolve(false);
				else
					context.calculate(b, resolve, reject);
			}, reject);
		});
		// L'opérateur logique "ou" (binaire associatif gauche)
		calculator.addOperator(lang['OrAssociation'], 1, 'left', function(context, resolve, reject, a, b) {
			context.calculate(a, function(result) {
				if (result)
					resolve(true);
				else
					context.calculate(b, resolve, reject);
			}, reject);
		});
		// Surcharge de la fonction Literal pour vérifier que les nombres correspondent bien à un numéro de ligne
		calculator.Literal = function(token) {
			var l = Calculator.prototype.Literal.apply(calculator, [token]);
			// Si l.literal, c'est une expression "1", "2", ... "N" ajoutée par "addLiteral" donc on accepte
			if (l.literal)
				return l;
			// Sinon, on rejette car ça correspond à d'autres valeurs comme true, false, du texte, des nombres autres, des dates/heures, ...  
			calculator.error('%0 is not a valid expression', [token], token.length);
		};
		return calculator;
	}

	/**
	 * Cette fonction crée un objet permettant l'évaluation des filtres.
	 *
	 * @param {String} langCode - le code (fr, en, ...) de la langue à utiliser, parmi les langues supportées $.fn.materialPopinFilters.langs
	 * @param {Array(name, title, nullable, operators, appendEditor, getEditorValue)} fields - la liste des champs disponibles
	 * @param {Array(field, operator, value)} filters - la liste des filtres définis par l'utilisateur
	 * @param {String} association - la manière de combiner les filtres, qui peut être 'and' (par défaut), 'or' ou 'custom' (expression)
	 * @param {String} expression - l'expression combinant les filtres, quand association est 'custom'
	 */
	function MaterialPopinFilterEvaluator(langCode, fields, filters, association, expression) {
		this.values = {};
		this.filters = filters.map(function(e) {
			// Récupérer le champ, pour son nom et ses opérateurs
			var field = fields.filter(function(f) { return f.name === e.field; })[0];
			var operator = field.operators[e.operator];
			var value = e.value;
			return { field: field, operator: operator, value: value };
		});
		if (association === 'and') {
			this.getResult = function() {
				return this.filters.every(this.getResultOf, this);
			};
		} else if (association === 'or') {
			this.getResult = function() {
				return this.filters.some(this.getResultOf, this);
			};
		} else if (association === 'custom') {
			// Langue pour les opérateurs "and", "or" et "not"
			var lang = $.fn.materialPopinFilters.langs[langCode];
			// Calculateur pour analyser l'expression
			var calculator = createCalculator(lang);
			// Contexte pour évaluer le résultat
			var context = new CalculatorContext(calculator);
			context.values = {};
			// Ajout des token "1", "2", ...
			for (var i = 1; i <= this.filters.length; i++) {
				calculator.addLiteral(i.toString(), function(context) {
					return context.values[this.token];
				});
			}
			// Parsing de l'expression
			var tree = calculator.parse(expression);
			// console.log(tree);
			this.getResult = function() {
				var result = null;
				for (var i = 1; i <= this.filters.length; i++) {
					var v = this.getResultOf(this.filters[i - 1]);
					context.values[i.toString()] = v;
				}
				// Ici, on joue sur le fait que le "calculate" appellera l'une des 2 fonctions de manière
				// SYNCHRONE car les litéraux et les opérateurs &&, || et ! sont synchrones.
				// Ca ne marcherait pas avec des fonctions asynchrones par contre.
				context.calculate(tree, function(value) {
					result = value;
				}, function(error) {
					throw error;
				});
				return result;
			};
		}
	}

	/** Permet de spécifier la valeur en cours pour un champ */
	MaterialPopinFilterEvaluator.prototype.setValue = function(name, value) {
		if (value === undefined)
			delete this.values[name];
		else
			this.values[name] = value;
	};

	/** Permet de spécifier la valeur en cours pour tous les champs en une fois */
	MaterialPopinFilterEvaluator.prototype.setValues = function(values) {
		this.values = values;
	};

	/** Méthode interne qui calcule la valeur d'un filtre */
	MaterialPopinFilterEvaluator.prototype.getResultOf = function(filter) {
		var input = this.values[filter.field.name];
		return filter.operator(input, filter.value);
	};

	/** Méthode qui calcule retourne la résultat de la combinaison de filtre pour les données spécifiées par setValue et/ou setValues */
	MaterialPopinFilterEvaluator.prototype.getResult = function() {
		// getResult est définie dans le constructeur pour faire 'and', 'or' ou 'custom'
		throw new Error('pas normal');
	};

	/** Exposer la méthode "MaterialPopinFilterEvaluator" à l'extérieur via "$.fn.materialPopinFilters.Evaluator" */
	$.fn.materialPopinFilters.Evaluator = MaterialPopinFilterEvaluator;

	/**
	 * Constructeur pour définir un champ disponible
	 *
	 * @param {String} name - le nom interne du champ
	 * @param {String} title  - l'intitulé du champ
	 * @param {Boolean} nullable - indique si le champ peut être vide
	 * @return {MaterialPopinFilterField} un nouveau champ, incomplet jusqu'à l'appel à une des méthodes "asXXX"
	 */
	function MaterialPopinFilterField(name, title, nullable) {
		// Le nom du champ disponible (les filtres de l'utilisateur utilisent le nom pour indiquer le champ associé)
		this.name = name;
		// L'intitulé du champ, qui apparait dans le combo d'ajout puis dans une colonne de la table
		this.title = title;
		// "nullable" indique si le champ peut être vide, et activera dans ce cas les opérateurs 'Vide' et 'Non vide'
		this.nullable = nullable;
		// Permet d'indiquer, en fonction du type de champ, les opérateurs, en dehors de 'isEmpty'/'isNotEmpty' (controllés par "nullable")
		this.operators = {};
		if (nullable) {
			this.operators.isEmpty = function(input) { return (typeof input === 'undefined') || (input === null) || (input === false) || (input === '') || (input === []); };
			this.operators.isNotEmpty = function(input) { return (typeof input !== 'undefined') && (input !== null) && (input !== false) && (input !== '') && (input !== []); };
		}
	}

	/** Cette méthode retourne les opérateurs dispo pour ce champ */
	MaterialPopinFilterField.prototype.getOperators = function() {
		// Les opérateurs supportés
		var result = [];
		// Les opérateurs disponibles
		['equals', 'notEquals', 'strictlyLess', 'less', 'strictlyGreater', 'greater', 'startsWith', 'notStartsWith', 'endsWith', 'notEndsWith', 'contains', 'notContains', 'isEmpty', 'isNotEmpty'].forEach((function(operator) {
			// Ajout si l'opérateur est supporté
			if (this.operators.hasOwnProperty(operator))
				result.push(operator);
		}).bind(this));
		return result;
	};

	/**
	 * Cette méthode doit être dérivée pour chaque type de champ pour indiquer comment créer un éditeur pour la colonne "Valeur"
	 *
	 * @param {jQuery} parent - l'élément DOM dans lequel ajouter l'éditeur
	 * @param {*} value - la valeur typée (number, boolean, String, ...) du filtre sur ce champ
	 * @param {String} langCode - la langue fr/en/de utilisée
	 */
	MaterialPopinFilterField.prototype.appendEditor = function(parent, value, langCode) {
		throw new Error('Implémentation manquante');
	};

	/**
	 * Cette méthode doit être dérivée pour chaque type de champ pour indiquer comment récupéer une valeur dans l'éditeur
	 *
	 * @param {jQuery} parent - l'élément DOM dans lequel l'éditeur a été ajouté
	 */
	MaterialPopinFilterField.prototype.getEditorValue = function(parent) {
		throw new Error('Implémentation manquante');
	};

	/**
	 * Cette méthode finalise un champ numérique, qui manipule des Number
	 *
	 * @param {Boolean} isInteger - indique si le champ est un entier (true) ou un flottant (false)
	 */
	MaterialPopinFilterField.prototype.asNumber = function(isInteger) {
		// Opérateurs disponibles pour les entiers
		$.extend(this.operators, {
			equals: function(input, value) { return (input || 0) === (value || 0); },
			notEquals: function(input, value) { return (input || 0) !== (value || 0); },
			strictlyLess: function(input, value) { return (input || 0) < (value || 0); },
			less: function(input, value) { return (input || 0) <= (value || 0); },
			strictlyGreater: function(input, value) { return (input || 0) > (value || 0); },
			greater: function(input, value) { return (input || 0) >= (value || 0); },
		});
		// L'éditeur est un "input[type=text]"
		this.appendEditor = function(parent, value, langCode) {
			$('<input class="form-control" type="text" />').val((value || '').toString()).appendTo(parent);
		};
		// Mais la valeur est renvoyée comme un entier ou un flottat, en fonction de "isInteger"
		this.getEditorValue = function(parent) {
			var s = parent.children('input').val();
			return isInteger ? parseInt(s) : parseFloat(s);
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ booléen, qui manipule des Boolean
	 */
	MaterialPopinFilterField.prototype.asBoolean = function() {
		// Opérateurs disponibles pour les booléens
		$.extend(this.operators, {
			equals: function(input, value) { return (input || false) === (value || false); },
			notEquals: function(input, value) { return (input || false) !== (value || false); },
		});
		// Pour les booléens, on choisi la valeur oui/non via un select dont un peut personnalisé le texte
		this.appendEditor = function(parent, value, langCode) {
			var lang = $.fn.materialPopinFilters.langs[langCode];
			$('<select class="form-control" style="padding-right: 16px;" />')
				.append($('<option value="true" />').text(lang['YesToken']).prop('selected', value !== false))
				.append($('<option value="false" />').text(lang['NoToken']).prop('selected', value === false))
				.appendTo(parent);
		};
		// Mais la valeur saisie est renvoyée comme un booléen
		this.getEditorValue = function(parent) {
			return parent.children('select').val() === 'true';
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ texte, qui manipule des String
	 */
	MaterialPopinFilterField.prototype.asString = function() {
		// Opérateurs disponibles pour les textes
		function lc(s) { return s ? s.toLowerCase() : ''; }
		$.extend(this.operators, {
			equals: function(input, value) { return lc(input).localeCompare(lc(value)) === 0; },
			notEquals: function(input, value) { return lc(input).localeCompare(lc(value)) !== 0; },
			startsWith: function(input, value) { return !value ? true : !input ? false : lc(input).indexOf(lc(value)) === 0; },
			notStartsWith: function(input, value) { return !value ? false : !input ? true : lc(input).indexOf(lc(value)) !== 0; },
			endsWith: function(input, value) { return !value ? true : !input ? false : lc(input).lastIndexOf(lc(value)) === input.length - value.length; },
			notEndsWith: function(input, value) { return !value ? false : !input ? true : lc(input).lastIndexOf(lc(value)) !== input.length - value.length; },
			contains: function(input, value) { return !value ? true : !input ? false : lc(input).indexOf(lc(value)) !== -1; },
			notContains: function(input, value) { return !value ? false : !input ? true : lc(input).indexOf(lc(value)) === -1; },
		});
		// Par contre, l'éditeur est un input[type=text] tout simple
		this.appendEditor = function(parent, value, langCode) {
			$('<input class="form-control" type="text" />').val(value || '').appendTo(parent);
		};
		// Et la valeur saisie simplement renvoyée en texte
		this.getEditorValue = function(parent) {
			return parent.children('input').val();
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ texte, avec autocomplétion, comme pour les noms et codes de client ou produit
	 *
	 * @param {Number} minLength - le nombre de caractères à tapper avant de commencer la recherche de suggestions
	 * @param {Function(term, callback(Array[String])} source - fonction de recherche d'occurences
	 */
	MaterialPopinFilterField.prototype.asAutocomplete = function(minLength, source) {
		// Les autocomplete travaillent avec des textes.
		this.asString();
		// Seul l'éditeur change pour proposer l'auto-complétion
		this.appendEditor = function(parent, value, langCode) {
			var input = $('<input class="form-control" autocomplete="off" type="text" />').val(value || '').appendTo(parent);
			input.autocomplete({
				minLength: minLength,
				appendTo: parent,
				source: function(request, response) {
					var term = request.term.split(',').pop();
					if (term)
						source(term, response);
					else
						response([]);
				},
				focus: function() {
					// prevent value inserted on focus
					return false;
				},
				select: function( event, ui ) {
					var terms = this.value.split(',');
					terms.pop();
					terms.push(ui.item.value);
					this.value = terms.join(',');
					return false;
				}
			});
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ sur date, qui manipule des "long" représentant des dates
	 *
	 * @param {String} format - indique le format utilisé pour afficher les dates
	 */
	MaterialPopinFilterField.prototype.asDate = function(format) {
		// On délègue à asDatetime, en indiquant que l'on veut les dates mais pas les heures
		return this.asDatetime(format, true, false);
	};

	/**
	 * Cette méthode finalise un champ sur heure, qui manipule des "long" représentant des heures
	 *
	 * @param {String} format - indique le format utilisé pour afficher les heures
	 */
	MaterialPopinFilterField.prototype.asTime = function(format) {
		// On délègue à asDatetime, en indiquant que l'on veut les heures mais pas les dates
		return this.asDatetime(format, false, true);
	};

	/**
	 * Cette méthode finalise un champ sur date+heure, qui manipule des "long" représentant des dates et/ou heures
	 *
	 * @param {String} format - indique le format utilisé pour afficher les valeurs
	 * @param {Boolean} pickDate - si false, désactive la saisie des dates (et crée donc un composant pour les heures)
	 * @param {Boolean} pickTime - si false, désactive la saisie des heures (et crée donc un composant pour les dates)
	 */
	MaterialPopinFilterField.prototype.asDatetime = function(format, pickDate, pickTime) {
		// Pour permettre d'appeler "new Filter(...).asDatetime('YYYY/MM/DD HH:mm'), les paramètres absents sont considérés "true"
		pickDate = (pickDate !== false); // true ou undefined
		pickTime = (pickTime !== false); // true ou undefined
		// Pour les champs date/heure, on gère les opérateurs [=, <>, <, <=, >=, >] qui utiliseront la comparaison
		var compare = function(input, value) {
			if (!input && !value) return 0;
			if (!input &&  value) return -1;
			if ( input && !value) return 1;
			return input - value;
		};
		$.extend(this.operators, {
			equals: function(input, value) { return compare(input, value) === 0; },
			notEquals: function(input, value) { return compare(input, value) !== 0; },
			strictlyLess: function(input, value) { return compare(input, value) < 0; },
			less: function(input, value) { return compare(input, value) <= 0; },
			strictlyGreater: function(input, value) { return compare(input, value) > 0; },
			greater: function(input, value) { return compare(input, value) >= 0; },
		});
		// L'éditeur est un input[type=text] avec un placeholder auquel on applique si disponible le composant "Bootstrap Datetimepicker"
		this.appendEditor = function(parent, value, langCode) {
			// Formattage de value (un "long") en texte pour l'utilisateur
			var text = value ? moment(value).format(format) : '';
			// Ajout de l'input avec valeur dans le parent
			var input = $('<input class="form-control" type="text" />').attr('placeholder', format).val(text).appendTo(parent);
			// Si le composant "Bootstrap Datetimepicker" est dispo, on l'utilise car plus joli qu'un <input type="text" />
			if (!! $.fn.datetimepicker) {
				// il faut dans ce cas que le (grand-)parent ait une position "relative"
				input.wrap('<div style="position: relative;" />').datetimepicker({
					locale: langCode,
					format: format,
					useCurrent: false,
					calendarWeeks: true
				});
			}
		};
		// La valeur saisie est renvoyée comme un "long", en prenant soin de vider la partie date ou heure si besoin
		this.getEditorValue = function(parent) {
			var text = parent.find('input.form-control').val();
			if (!text)
				return undefined;
			var value = moment(text, format);
			if (!pickDate)
				value = value.year(1970).month(0).date(1);
			if (!pickTime)
				value = value.startOf('day');
			return value.toDate().getTime();
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ sur liste, qui permet de sélectionner un tableau d'id
	 *
	 * @param {Array} options - la liste des options sélectionnables avec "id" (entier) et "title" (texte)
	 * @param {Object} multiselectOptions - pour personnaliser le composant "Bootstrap Multiselect", si trouvé et utilisé
	 */
	MaterialPopinFilterField.prototype.asList = function(options, multiselectOptions, idProperty, titleProperty) {
		// Opérateurs disponibles pour les listes
		function testAccepted(input, value, isEquals) {
			// Si le filtre est inactif, on ne filtre rien, que ce soit avec equals ou notEquals
			if (typeof value === 'undefined' || value.length === 0)
				return true;
			// Si le filtre est actif mais que le champ est vide, on refuse pour equals mais on accepte pour notEquals
			if (typeof input === 'undefined' || input === null || input.length === 0)
				return !isEquals;
			// Sinon, il faut vérifier si l'id (ou un des ids) est dans le tableau "value"
			function test(id) {
				return value.indexOf(id) !== -1;
			}
			var accepted = (typeof input === 'number') ? test(input) : input.some(test);
			return accepted ? isEquals : !isEquals;
		}
		$.extend(this.operators, {
			equals: function(input, value) { return testAccepted(input, value, true); },
			notEquals: function(input, value) { return testAccepted(input, value, false); },
		});
		// L'éditeur est un composant "select" auquel on applique si disponible le composant "Bootstrap Multiselect"
		this.appendEditor = function(parent, value, langCode) {
			// Récupération de la traduction
			var lang = $.fn.materialPopinFilters.langs[langCode];
			// Création du <select />
			var select = $('<select multiple class="form-control" style="padding-right: 16px;" />');
			// Ajout des options
			select.append(options.map(function(o) {
				return $('<option />').attr('value', o[idProperty || 'id'].toString()).text(o[titleProperty || 'title']).prop('selected', value && (value.indexOf(o[idProperty || 'id']) >= 0)).get(0);
			}));
			// Ajout du select au parent donné
			select.appendTo(parent);
			// Si le composant "Bootstrap Multiselect" est dispo, on l'utilise car plus joli qu'un <select multiple />
			if (!! $.fn.multiselect) {
				select.multiselect($.extend({
					buttonText: function(options) {
						return (!options || options.length === 0) ? '...' : options.get().map(function(o) { return o.textContent; }).join(', ');
					},
					buttonTitle: function(options) {
						return (!options || options.length === 0) ? '' : options.get().map(function(o) { return o.textContent; }).join('\n');
					},
					buttonWidth: '100%',
					dropRight: true,
					maxHeight: 200,
				 	includeSelectAllOption: true,
				 	selectAllText: lang['SelectAllText'],
					enableFiltering: true,
					enableCaseInsensitiveFiltering : true
				}, multiselectOptions));
			}
		};
		// La valeur saisie est renvoyée comme un tableau d'entier
		this.getEditorValue = function(parent) {
			return (parent.find('select').val() || []).map(function(s) { return parseInt(s); });
		};
		return this;
	};

	/**
	 * Cette méthode finalise un champ sur arborescence, qui permet de sélectionner un tableau d'id
	 *
	 * @param {Array} options - la liste des options sélectionnables avec "id" (entier), "title" (texte) et éventuellement "children" (récursivité)
	 * @param {Object} multiselectOptions - pour personnaliser le composant "Bootstrap Multiselect", si trouvé et utilisé
	 */
	MaterialPopinFilterField.prototype.asTree = function(options, multiselectOptions, idProperty, titleProperty) {
		var lastValue, lastValueSelectionAndDescendants;

		idProperty = idProperty || 'id';
		titleProperty = titleProperty || 'title';

		function add(option) { // ajoute l'option récursivement
			lastValueSelectionAndDescendants.push(option.id);
			if (option.children)
				option.children.forEach(add);
		}
		function check(option, value) { // vérifie si l'option est présente
			if (value.indexOf(option[idProperty]) !== -1)
				add(option);
			else if (option.children)
				option.children.forEach(function(child) {
					check(child, value);
				});
		}

		function equals(options, input, value) {
			if (!input)
				return false;
			if (typeof lastValueSelectionAndDescendants === 'undefined' || (lastValue !== value)) {
				lastValue = value;
				lastValueSelectionAndDescendants = [];
				options.forEach(function(option) {
					check(option, value);
				});
			}

			if(input instanceof Array) {
				// On cherche si il y a une intersection entre input & lastValueSelectionAndDescendants
				return input.some(function(v) {return lastValueSelectionAndDescendants.indexOf(v) !== -1;});
			}
			return lastValueSelectionAndDescendants.indexOf(input) !== -1;
		}
		// Opérateurs disponibles pour les listes
		$.extend(this.operators, {
			equals: function(input, value) { return (typeof value === 'undefined' || value.length === 0) ? true/*filtre inactif*/ : equals(options, input, value); },
			notEquals: function(input, value) { return (typeof value === 'undefined' || value.length === 0) ? true/*filtre inactif*/ : !equals(options, input, value); },
		});
		// L'éditeur est un composant "select" auquel on applique si disponible le composant "Bootstrap Multiselect"
		this.appendEditor = function(parent, value, langCode) {
			// Récupération de la traduction
			var lang = $.fn.materialPopinFilters.langs[langCode];
			// Création du <select />
			var select = $('<select multiple class="form-control" style="padding-right: 16px;" />');
			// Ajout des options RECURSIVEMENT
			function append(list, textPrefix, pathPrefix, depth) {
				list.forEach(function(o) {
					$('<option />').prop('selected', value && (value.indexOf(o[idProperty]) >= 0))
						.attr('value', o[idProperty].toString())
						.attr('data-path', pathPrefix + o[titleProperty])
						.text(textPrefix + o[titleProperty])
						.appendTo(select);
					if (o.children && o.children.length)
						append(o.children, textPrefix + '\u00A0\u00A0', pathPrefix + o[titleProperty] + ' > ', depth + 1);
				});
			}

			// Fonction qui affiche le chemin complet des éléments sélectionnés
			function fullText(options, separator, noValue) {
				if (!options || options.length === 0)
					return noValue;
				return options.get().map(function(option) {
					return $(option).attr('data-path');
				}).join(separator);
			}

			append(options, '', '', 0);
			// Ajout du select au parent donné
			select.appendTo(parent);
			// Si le composant "Bootstrap Multiselect" est dispo, on l'utilise car plus joli qu'un <select multiple />
			if (!! $.fn.multiselect) {
				// Activation du composant
				select.multiselect($.extend({
					buttonText: function(options) {
						return fullText(options, ', ', '...');
					},
					buttonTitle: function(options) {
						return fullText(options, '\n', '');
					},
					buttonWidth: '100%',
					dropRight: true,
					maxHeight: 200,
				 	includeSelectAllOption: true,
				 	selectAllText: lang['SelectAllText'],
					enableFiltering: true,
					enableCaseInsensitiveFiltering : true
				}, multiselectOptions));
			}
		};
		// La valeur saisie est renvoyée comme un tableau d'entier
		this.getEditorValue = function(parent) {
			return (parent.find('select').val() || []).map(function(s) { return parseInt(s); });
		};
		return this;
	};

	/** Exposer la méthode "MaterialPopinFilterField" à l'extérieur via "$.fn.materialPopinFilters.Field" */
	$.fn.materialPopinFilters.Field = MaterialPopinFilterField;

	/** Traduction des libellés utilisés dans les différentes langues supportées */
	$.fn.materialPopinFilters.langs = {
		fr: {
			ValidateButton: 'Valider',
			ClearButton: 'Supprimer tous les filtres',
			CancelButton: 'Annuler',
			AddButton: 'Ajouter un champ',
			AndAssociation: 'et',
			OrAssociation: 'ou',
			CustomAssociation: 'Personnalisation',
			FormulaPlaceholder: 'Formule (par exemple &quot;1 et (2 ou 3)&quot;)',
			FormulaError: 'Formule incorrecte',
			FormulaResultTypeError: 'La formule doit retourner un booléen',
			NumberColumn: 'N°',
			FieldColumn: 'Champ',
			OperatorColumn: 'Opérateur',
			ValueColumn: 'Valeur',
			RemoveButton: 'Supprimer le critère',
			NotToken: 'pas',
			YesToken: 'oui',
			NoToken: 'non',
			SelectAllText: 'tout (dé)sélectionner',

			errors: {
				'End of formula has been reached': 'La fin de la formule a été atteinte',
				'Un-terminated string started at position %0': 'Chaine non terminée commencée à la position %0',
				'Found "%1" but expecting "%2" at position %0': '"%1" trouvé mais "%2" attendu à la position %0',
				'Expecting a value but found "%1" at position %0': '"%1" trouvé mais une valeur était attendue à la position %0',
				'%0 is not a valid line number': '%0 n\'est pas un numéro de ligne valide',
				'%0 is not a valid expression': '%0 n\'est pas une expression correcte',
			},
			operators: {
				equals: 'Egal à', notEquals: 'Différent de',
				isEmpty: 'Vide', isNotEmpty: 'Non vide',
				less: 'Inférieur ou égal à', strictlyLess: 'Inférieur à',
				greater: 'Supérieur ou égal à', strictlyGreater: 'Supérieur à',
				startsWith: 'Commence par', notStartsWith: 'Ne commence pas par',
				endsWith: 'Se termine par', notEndsWith: 'Ne se termine pas par',
				contains: 'Contient', notContains: 'Ne contient pas' }
		},
		en: {
			ValidateButton: 'Validate',
			ClearButton: 'Clear all filters',
			CancelButton: 'Cancel',
			AddButton: 'Add field',
			AndAssociation: 'and',
			OrAssociation: 'or',
			CustomAssociation: 'Customization',
			FormulaPlaceholder: 'Formula (such as &quot;1 and (2 or 3)&quot;)',
			FormulaError: 'Invalid formula',
			FormulaResultTypeError: 'The formula must return a boolean',
			NumberColumn: 'N°',
			FieldColumn: 'Field',
			OperatorColumn: 'Operator',
			ValueColumn: 'Value',
			RemoveButton: 'Remove field',
			NotToken: 'not',
			YesToken: 'yes',
			NoToken: 'no',
			SelectAllText: 'select all / none',

			errors: {
				// pas besoin, les messages sont en anglais par défaut
			},
			operators: {
				equals: 'Equals', notEquals: 'Is different of',
				isEmpty: 'Is empty', isNotEmpty: 'Is not empty',
				less: 'Is less than', strictlyLess: 'Is strictly less than',
				greater: 'Is greater than', strictlyGreater: 'Is strictly greater than',
				startsWith: 'Starts with', notStartsWith: 'Does not start with',
				endsWith: 'Ends with', notEndsWith: 'Does not end with',
				contains: 'Contains', notContains: 'Does not contain' }
		},
		de: {
			ValidateButton: 'Validieren',
			ClearButton: 'alle Kriterien entfernen',
			CancelButton: 'Abbrechen',
			AddButton: 'ein Kriterium fügen',
			AndAssociation: 'und',
			OrAssociation: 'oder',
			CustomAssociation: 'Anpassung',
			FormulaPlaceholder: 'Formel (zum Beispiel &quot;1 und (2 oder 3)&quot;)',
			FormulaError: 'Ungültige Formel',
			FormulaResultTypeError: 'Die Formel muss einen Booleschen Wert zurückgeben',
			NumberColumn: '',//Anzahl
			FieldColumn: 'Kriterium',
			OperatorColumn: 'Operator',
			ValueColumn: 'Wert',
			RemoveButton: 'das Kriterium löschen',
			NotToken: 'nicht',
			YesToken: 'ya',
			NoToken: 'nein',
			SelectAllText: 'wählen alles/nichts aus',

			errors: {
				'End of formula has been reached': 'Das Ende der Formel wurde erreicht',
				'Un-terminated string started at position %0': 'Zeichenkette an Position %0 gestartet aber nicht abgeschlossen',
				'Found "%1" but expecting "%2" at position %0': '"%1" gefunden aber "%2" war erwartet an Position %0',
				'Expecting a value but found "%1" at position %0': '"%1" gefunden aber ein Wert war erwartet an Position %0',
				'%0 is not a valid line number': '%0 ist keine gültige Zahl',
				'%0 is not a valid expression': '%0 ist kein gültiger Ausdruck',
			},
			operators: { equals: 'ist gleich', notEquals: 'ist nicht gleich',
				isEmpty: 'ist leer', isNotEmpty: 'ist nicht leer',
				less: 'ist kleiner als', strictlyLess: 'ist strikt kleiner als',
				greater: 'ist größer als', strictlyGreater: 'ist strikt größer als',
				startsWith: 'beginnt mit', notStartsWith: 'beginnt nicht mit',
				endsWith: 'endet mit', notEndsWith: 'ended nicht mit',
				contains: 'enthält', notContains: 'enthält nicht' }
		}
	};

})(window.jQuery, window.moment, window.Calculator, window.CalculatorContext);